import axios from "axios";
// import config from "../config";

// Create axios instance with base URL
const axiosInstance = axios.create({
  baseURL: "http://localhost:8001",
});

// Add request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    console.log("config", config);
    console.log("config.headers", config.headers);
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
// axiosInstance.interceptors.response.use(
//   (response) => response,
//   (error) => {
//     if (error.response?.status === 403 || error.response?.status === 401) {
//       // Clear token and redirect to login
//       console.log("Clearing token and redirecting to login");
//       localStorage.removeItem('token');
//       window.location.href = '/login';
//     }
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
